import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { authAPI } from '../services/api';

const Accesso: React.FC = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const code = params.get('code') || '';
    if (!code) {
      navigate('/login', { replace: true });
      return;
    }
    let active = true;
    authAPI.handoff(code)
      .then((data: { token: string }) => {
        if (!active) return;
        localStorage.setItem('token', data.token);
        window.location.replace('/');
      })
      .catch(() => {
        if (active) setError('Il collegamento non è più valido. Entra con username e password.');
      });
    return () => {
      active = false;
    };
  }, [navigate, params]);

  if (!error) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
        <CircularProgress size={22} />
        <Typography>Apro la rilevazione presenze…</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 2, px: 2 }}>
      <Typography>{error}</Typography>
      <Button variant="contained" onClick={() => navigate('/login', { replace: true })}>Vai al login</Button>
    </Box>
  );
};

export default Accesso;
